import { useSafetyTranslation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { CockpitNavigatorTreeRow } from '../../../components/cockpitNavigatorTreeRow'
import { countDocuments } from '../../lib/countDocuments'
import type { IDocumentsNavigatorNode } from '../../types'

import styles from './DocumentsNavigatorTree.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.navigation
interface IProps {
  nodes: IDocumentsNavigatorNode[]
  query: string
  selectedKey: string | null
  expandedKeys: Set<string>
  onToggle: (key: string) => void
  onSelect: (key: string) => void
  depth?: number
}
const matches = (node: IDocumentsNavigatorNode, query: string): boolean =>
  node.label.toLowerCase().includes(query) ||
  Boolean(node.description?.toLowerCase().includes(query)) ||
  node.children.some((child) => matches(child, query))

export const DocumentsNavigatorTree = ({
  nodes,
  query,
  selectedKey,
  expandedKeys,
  onToggle,
  onSelect,
  depth = 0,
}: IProps) => {
  const t = useSafetyTranslation()
  return (
    <ul className={styles.list}>
      {nodes
        .filter((node) => !query || matches(node, query))
        .map((node) => {
          const hasChildren = node.children.length > 0
          const expanded = Boolean(query) || expandedKeys.has(node.key)
          return (
            <li key={node.key}>
              <CockpitNavigatorTreeRow
                label={node.label}
                description={node.description}
                count={countDocuments(node.sections)}
                depth={depth}
                selected={selectedKey === node.key}
                expandable={hasChildren}
                expanded={expanded}
                toggleTitle={t(expanded ? KEYS.collapse : KEYS.expand)}
                onToggle={() => onToggle(node.key)}
                onSelect={() => onSelect(node.key)}
              />
              {hasChildren && expanded && (
                <DocumentsNavigatorTree
                  nodes={node.children}
                  depth={depth + 1}
                  query={query}
                  selectedKey={selectedKey}
                  expandedKeys={expandedKeys}
                  onToggle={onToggle}
                  onSelect={onSelect}
                />
              )}
            </li>
          )
        })}
    </ul>
  )
}
